export const resources = {
  en: {
    translation: {
      'formSelect.all.placeholder': 'Please select',
      'page.signin.title': 'Welcome!',
      'page.signin.subtitle':
        'Log in below to apply for and manage your licences or certificates.',
      'page.signin.individual.name': 'Individual',
      'page.signin.individual.description':
        'Login as an individual to apply for a new certificate, or to manage an existing one. Also to register as a sole trader firearms dealer.',
      'page.signin.organisation.name': 'Organisation',
      'page.signin.organisation.description':
        'Login as an organisation to apply for registration as a firearms dealer, or to manage an existing registration.',
      'page.signin.commercial.name': 'Commercial Company',
      'page.signin.commercial.description':
        'Log in as commercial company to apply for a licence or manage your current licences and provide your business in alignment with national laws.',
      'page.signin.button.login': 'Login',
      'page.signin.button.createAccount': 'Create an account',
      'page.signin.loginAs.INDIVIDUAL': 'Log In as Individual',
      'page.signin.loginAs.INDIVIDUAL.description':
        'Log in as individual to apply for a licence or manage your current licences',
      'page.signin.input.email': 'Email address',
      'page.signin.input.password': 'Password',
      'page.signin.button.forgotPassword': 'Forgot Password?',
      'page.signin.loginAs.ORGANISATION': 'Log In as Organisation',
      'page.signin.loginAs.ORGANISATION.description':
        'Log in as organisation to apply for a licence or manage your current licences',
      'page.signin.loginAs.COMMERCIAL': 'Log In as Commercial Company',
      'page.signin.loginAs.COMMERCIAL.description':
        'Log in as commercial company to apply for a licence or manage your current licences',
      'page.createAccount.INDIVIDUAL': 'Create an Account for Individual',
      'page.createAccount.INDIVIDUAL.subtitle':
        'At cursus faucibus a sed tincidunt at orci elit. Nascetur scelerisque enim arcu leo. Libero mauris malesuada adipiscing velit mus tortor. Amet ullamcorper adipiscing.',
      'page.createAccount.input.email': 'Email Address',
      'page.createAccount.input.prefix': 'Prefix Phone Number',
      'page.createAccount.input.phone': 'Phone Number',
      'page.createAccount.input.birth': 'Date of Birth',
      'page.createAccount.check.termsAndConditions1': 'I accept ',
      'page.createAccount.check.termsAndConditions2': 'Terms and conditions',
      'page.createAccount.check.termsAndConditions3': ' of the Firearm Licence Portal.',
      'page.createAccount.button.create': 'Create an account',
      'page.createAccount.button.cancel': 'Cancel',
      'page.createAccount.ORGANISATION': 'Create an Account for Organisation',
      'page.createAccount.ORGANISATION.subtitle':
        'At cursus faucibus a sed tincidunt at orci elit. Nascetur scelerisque enim arcu leo. Libero mauris malesuada adipiscing velit mus tortor. Amet ullamcorper adipiscing.',
      'page.createAccount.COMMERCIAL': 'Create an Account for Commercial Company',
      'page.createAccount.COMMERCIAL.subtitle':
        'At cursus faucibus a sed tincidunt at orci elit. Nascetur scelerisque enim arcu leo. Libero mauris malesuada adipiscing velit mus tortor. Amet ullamcorper adipiscing.',
      'page.createAccount.create.success': 'Your account has been created successfully.',
      'page.createAccount.validation.email.format':
        'Incorrect email format. Email must contain @ and a dot.',
      'page.createAccount.validation.email.required': 'This field is required.',
      'page.createAccount.validation.prefix.required': 'This field is required.',
      'page.createAccount.validation.phone.required': 'This field is required.',
      'page.createAccount.validation.phone.valueIsNotCorrect': 'Entered value is not correct.',
      'page.createAccount.validation.phone.maxNumberCharacters':
        'This field should have max 15 characters.',
      'page.createAccount.validation.phone.minNumberCharacters':
        'This field should have min 5 characters.',
      'page.createAccount.validation.birth.required': 'This field is required.',
      'page.createAccount.validation.birth.years': 'User must be at least 18 years old.',
      'page.createAccount.validation.termsAndConditions.required': 'This field is required.',

      'page.forgotPassword.title': 'Forgot Password?',
      'page.forgotPassword.subtitle':
        'Please enter your email address to set a new password to access Firearm Licence Portal.',
      'page.forgotPassword.input.email': 'Email',
      'page.signin.button.reset': 'Reset Password',
      'page.signin.button.backToStart': 'Back To Start Page',
      'page.forgotPassword.subtitle2':
        'The reset password link has been sent to the provided email address. Click on the link and set a new password to access FireCycle. The link is valid for 24 hours.',
      'page.forgotPassword.subtitle3': 'Didn’t receive an email?',
      'page.signin.button.resend': 'Resend Reset Link',
      'page.signin.sms.title': 'Two Factor Authentication',
      'page.signin.sms.subtitle':
        'We’ve sent a verification code to your phone via SMS. Please enter it below to continue.',
      'page.signin.email.subtitle':
        'We’ve sent a verification code to your email. Please enter it below to continue.',
      'page.signin.input.authCode.sms': 'SMS Code',
      'page.signin.input.authCode.email': 'Email Code',
      'page.signin.button.verifyCode': 'Verify Code',
      'page.signin.button.resendCode': 'Resend Code',
      'page.signin.choose.title': 'Two Factor Authentication Method',
      'page.signin.choose.subtitle':
        'Please select your preferred method to receive the verification code.',
      'page.signin.choose.button.next': 'Next',
      'page.signin.choose.button.back': 'Back to start page',

      'page.myProfile.button.editAccount': 'Edit Account Data',
      'page.myProfile.button.edit': 'Edit',
      'page.myProfile.title': 'My Profile',
      'page.myProfile.accountData': 'Account Data',
      'page.myProfile.personalData': 'Personal Data',
      'page.myProfile.homeAddress': 'Home Address',
      'page.myProfile.accountData.accountEmail': 'Account Email',
      'page.myProfile.accountData.userType': 'User Type',
      'page.myProfile.accountData.mobilePhone': 'Mobile Phone',
      'page.myProfile.accountData.notificationChannels': 'Notification Channels',
      'page.myProfile.personalData.nameAndSurname': 'Name and Surname',
      'page.myProfile.personalData.gender': 'Gender',
      'page.myProfile.personalData.previousNameAndSurname': 'Previous Name and Surname',
      'page.myProfile.personalData.dateOfBirth': 'Date of Birth',
      'page.myProfile.personalData.placeOfBirth': 'Place of Birth',
      'page.myProfile.personalData.nationality': 'Nationality',
      'page.myProfile.personalData.personalId': 'Personal ID',
      'page.myProfile.personalData.identityDocumentType': 'Identity Document Type',
      'page.myProfile.personalData.documentNumber': 'Document Number',
      'page.myProfile.personalData.maritalStatus': 'Marital Status',
      'page.myProfile.homeAddress.homeAddress': 'Home Address',
      'page.myProfile.homeAddress.stateProvince': 'State/Province',
      'page.myProfile.homeAddress.country': 'Country',
      'page.myProfile.homeAddress.homePhoneNumber': 'Home Phone Number',
      'page.myProfile.accountData.edit.title': 'Edit Account Data',
      'page.myProfile.accountData.edit.label.mandatoryField': 'Mandatory Field',
      'page.myProfile.accountData.edit.input.emailAddress': 'Email Address',
      'page.myProfile.accountData.edit.input.retypeEmailAddress': 'Retype Email Address',
      'page.myProfile.accountData.edit.select.prefixPhoneNumber': 'Prefix Phone Number',
      'page.myProfile.accountData.edit.input.phoneNumber': 'Phone Number',
      'page.myProfile.accountData.edit.label.notification': 'Notification Channel',
      'page.myProfile.accountData.edit.checkbox.email': 'Email',
      'page.myProfile.accountData.edit.checkbox.sms': 'SMS',
      'page.myProfile.accountData.edit.button.save': 'Save',
      'page.myProfile.accountData.edit.input.smsCode': 'SMS Code',

      'applicationStatus.NEW_APPLICATION': 'New Application',
      'applicationStatus.DRAFTING': 'Drafting',
      'applicationStatus.SUBMITTED': 'Submitted',
      'applicationStatus.ASSESSMENT': 'Assessment',
      'applicationStatus.ACTION_REQUIRED': 'Action Required',
      'applicationStatus.APPROVED': 'Approved',
      'applicationStatus.DENIED': 'Denied',

      'page.applicationDetails.conversation.button.add': 'Add Comment',
      'page.applicationDetails.conversation.table.creationDate': 'Creation Date',
      'page.applicationDetails.conversation.table.userName': 'User Name',
      'page.applicationDetails.conversation.table.comment': 'Comment',
    },
  },
};
